import { render, staticRenderFns } from "./CmfPickupStep2.vue?vue&type=template&id=54c1e833&scoped=true"
import script from "./CmfPickupStep2.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1e833",
  null
  
)

export default component.exports